import React from 'react';
import { User, Mic, MicOff, Video, VideoOff, MicOff as MuteIcon, UserX, Hand } from 'lucide-react';
import { Participant } from '../types/meeting.types';

interface ParticipantsPanelProps {
  participants: Participant[];
  isHost: boolean;
  onMuteParticipant?: (participantId: string) => void;
  onKickParticipant?: (participantId: string) => void;
}

const ParticipantsPanel: React.FC<ParticipantsPanelProps> = ({
  participants,
  isHost,
  onMuteParticipant,
  onKickParticipant,
}) => {
  return (
    <div className="h-full min-h-0 flex flex-col">
      <div className="hidden md:block p-4 border-b border-white/10 flex-shrink-0">
        <h3 className="text-white font-semibold">Katılımcılar ({participants.length})</h3>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto p-4 space-y-3">
        {participants.map((participant) => {
          const canModerate =
            isHost &&
            !participant.isCurrentUser &&
            !participant.isHost &&
            participant.id !== 'local';

          return (
            <div
              key={participant.id}
              className="flex items-center gap-3 p-3 bg-white/5 rounded-lg"
            >
              <div className="w-10 h-10 bg-purple-600/30 rounded-full flex items-center justify-center flex-shrink-0">
                <User className="w-5 h-5 text-purple-400" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  {participant.handRaised && (
                    <Hand className="w-3.5 h-3.5 text-amber-400 flex-shrink-0" />
                  )}
                  <p className={`text-sm font-medium truncate ${
                    participant.handRaised ? 'text-amber-300' : 'text-white'
                  }`}>
                    {participant.name}
                  </p>
                  {participant.isHost && (
                    <span className="text-[10px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded bg-amber-500/20 text-amber-300 border border-amber-500/30">
                      Toplantı Sahibi
                    </span>
                  )}
                </div>
                {participant.isCurrentUser && (
                  <p className="text-gray-400 text-xs">Siz</p>
                )}
              </div>
              <div className="flex items-center gap-1.5 flex-shrink-0">
                {participant.isAudioEnabled ? (
                  <Mic className="w-4 h-4 text-green-400" />
                ) : (
                  <MicOff className="w-4 h-4 text-red-400" />
                )}
                {participant.isVideoEnabled ? (
                  <Video className="w-4 h-4 text-green-400" />
                ) : (
                  <VideoOff className="w-4 h-4 text-red-400" />
                )}
                {canModerate && (
                  <>
                    <button
                      type="button"
                      onClick={() => onMuteParticipant?.(participant.id)}
                      className="p-1.5 rounded-lg bg-white/10 hover:bg-amber-600/30 text-amber-300 transition"
                      title="Mikrofonu kapat"
                      aria-label={`${participant.name} mikrofonunu kapat`}
                    >
                      <MuteIcon className="w-4 h-4" />
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        if (window.confirm(`${participant.name} toplantıdan atılsın mı?`)) {
                          onKickParticipant?.(participant.id);
                        }
                      }}
                      className="p-1.5 rounded-lg bg-white/10 hover:bg-red-600/30 text-red-300 transition"
                      title="Toplantıdan at"
                      aria-label={`${participant.name} toplantıdan at`}
                    >
                      <UserX className="w-4 h-4" />
                    </button>
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ParticipantsPanel;
